import { Action } from '@ngrx/store';
import { ICarHireSubBookingResponse } from '@shared/shared/interfaces/travel-car-hire.interfaces';

export const VIEW_CAR_SUB_BOOKING = '[Car Hire Sub Booking] View car hire sub booking';
export const VIEW_CAR_SUB_BOOKING_SUCCESS = '[Car Hire Sub Booking] View car hire sub booking success';
export const VIEW_CAR_SUB_BOOKING_FAILURE = '[Car Hire Sub Booking] View car hire sub booking failure';

export const CREATE_CAR_SUB_BOOKING = '[Car Hire Sub Booking] Create car hire sub booking';
export const CREATE_CAR_SUB_BOOKING_SUCCESS = '[Car Hire Sub Booking] Create car hire sub booking success';
export const CREATE_CAR_SUB_BOOKING_FAILURE = '[Car Hire Sub Booking] Create car hire sub booking failure';

export const CLEAR_CAR_SUB_BOOKING = '[Car Hire Sub Booking] Clear car hire sub booking';

export const RESTORE_CAR_HIRE_SUB_BOOKING = '[Car Hire Sub Booking] Restore car hire sub booking';
export const RESTORE_CAR_HIRE_SUB_BOOKING_SUCCESS = '[Car Hire Sub Booking] Restore car hire sub booking success';

export const PATCH_CAR_SUB_BOOKING_TRAVELLERS = '[Car Hire Sub Booking] Patch car hire sub booking travellers';
export const PATCH_CAR_SUB_BOOKING_TRAVELLERS_SUCCESS =
  '[Car Hire Sub Booking] Patch car hire sub booking travellers success';
export const PATCH_CAR_SUB_BOOKING_TRAVELLERS_FAILURE =
  '[Car Hire Sub Booking] Patch car hire sub booking travellers failure';
export const CLEAR_CAR_TRAVELLER_PATCH = '[Travel Booking] Clear car traveller patch';

export class ClearCarSubBooking implements Action {
  readonly type = CLEAR_CAR_SUB_BOOKING;
}

export class ViewCarSubBooking implements Action {
  readonly type = VIEW_CAR_SUB_BOOKING;
}

export class ViewCarSubBookingSuccess implements Action {
  readonly type = VIEW_CAR_SUB_BOOKING_SUCCESS;
  constructor(public payload: ICarHireSubBookingResponse) {}
}

export class ViewCarSubBookingFailure implements Action {
  readonly type = VIEW_CAR_SUB_BOOKING_FAILURE;
  constructor(public payload: any) {}
}

export class CreateCarSubBooking implements Action {
  readonly type = CREATE_CAR_SUB_BOOKING;
}

export class CreateCarSubBookingSuccess implements Action {
  readonly type = CREATE_CAR_SUB_BOOKING_SUCCESS;
  constructor(public payload: ICarHireSubBookingResponse) {}
}

export class CreateCarSubBookingFailure implements Action {
  readonly type = CREATE_CAR_SUB_BOOKING_FAILURE;
  constructor(public payload: any) {}
}

export class RestoreCarHireSubBooking implements Action {
  readonly type = RESTORE_CAR_HIRE_SUB_BOOKING;
}

export class RestoreCarHireSubBookingSuccess implements Action {
  readonly type = RESTORE_CAR_HIRE_SUB_BOOKING_SUCCESS;
  constructor(public payload: ICarHireSubBookingResponse) {}
}

export class PatchCarSubBookingTravellers implements Action {
  readonly type = PATCH_CAR_SUB_BOOKING_TRAVELLERS;
  constructor(public payload: any) {}
}

export class PatchCarSubBookingTravellersSuccess implements Action {
  readonly type = PATCH_CAR_SUB_BOOKING_TRAVELLERS_SUCCESS;
  constructor(public payload: any) {}
}

export class PatchCarSubBookingTravellersFailure implements Action {
  readonly type = PATCH_CAR_SUB_BOOKING_TRAVELLERS_FAILURE;
  constructor(public payload: any) {}
}

export class ClearCarTravellerPatch implements Action {
  readonly type = CLEAR_CAR_TRAVELLER_PATCH;
}

export type TravelCarHireSubBookingActions =
  | ClearCarSubBooking
  | ViewCarSubBooking
  | ViewCarSubBookingSuccess
  | ViewCarSubBookingFailure
  | CreateCarSubBooking
  | CreateCarSubBookingSuccess
  | CreateCarSubBookingFailure
  | RestoreCarHireSubBooking
  | RestoreCarHireSubBookingSuccess
  | PatchCarSubBookingTravellers
  | PatchCarSubBookingTravellersSuccess
  | PatchCarSubBookingTravellersFailure
  | ClearCarTravellerPatch;
